// @ts-nocheck - TODO: properly type this file!

import React from 'react';
import headAvatar from '@/assets/images/HeadAvatar.svg';
import { CustomTitle } from '../../../components';
import { Contact, CourierProviderData } from './types';
import DirectContactDirectory from './DirectContactDirectory';

interface OnChangePayload {
  id: string;
  action: 'add' | 'remove';
  contact: Contact;
}

type SupportContactPickerProps = {
  providerData: CourierProviderData;
  onChange?: (payload: OnChangePayload) => void;
  workingContacts?: [];
  handleEditFromList: (apiContact) => void;
  handleOpenAddNote: (apiContact) => void;
};

const SupportContactPicker: React.FC<SupportContactPickerProps> = ({
  providerData,
  handleEditFromList,
  handleOpenAddNote,
  onChange,
  workingContacts,
}) => {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          marginBottom: 16,
        }}
      >
        <img src={headAvatar} />
        <CustomTitle
          text='Select preferred general support contacts'
          fontSize='16px'
          lineHeight='20px'
          fontWeight='600'
          marginBottom='0px'
        />
      </div>

      <DirectContactDirectory
        onEdit={handleEditFromList}
        onAddNote={handleOpenAddNote}
        onChange={onChange}
        providerData={providerData}
        workingContacts={workingContacts}
      />
    </div>
  );
};

export default SupportContactPicker;
